export function hourToSecend(value) {
    const minute = value * 60
    const hour = minute * 60
    return hour
}
